(function() {
	var menu = document.querySelector('.menu');
	if (menu) {
		document.querySelector('.menu__toggle').addEventListener('click', function(e) {
			e.preventDefault();
			menu.classList.toggle('menu--active');
			this.classList.toggle('is-active');
		});
	}

	menuItems = document.querySelectorAll('.header__menu');
	if (menuItems.length) {
		document.querySelector('.header__toggle').addEventListener('click', function(e) {
			e.preventDefault();
			for (var i = 0; i < menuItems.length; i++) {
				menuItems[i].classList.toggle('header__menu--active');
			}
			this.classList.toggle('is-active');
		});
	}

	var codeboxes = document.querySelectorAll('input.codebox');
	var onCodeChange = function(e) {
		
		// if back arrow or backspace is pressed
		var goBack = (e.keyCode === 8 || e.keyCode === 37);
		
		// if forward arrow is pressed
		var goForward = (e.keyCode === 39);
		 
		var val = this.value + "";
		
		var nextBox = this.nextSibling;
		if (nextBox) {
			if (goForward || val.length >= 1) {
				if (val.length > 1) {
					this.value = val.substring(0,1);
				}
				nextBox.focus();
				return;
			}
		}
		else {
			if (val.length >= 1) {
				this.value = val.substring(0,1);
				return
			}
		}
		var prevBox = this.previousSibling;
		if (prevBox && goBack) {
			prevBox.focus()
		}
		//nextBox.focus();
	};
	for (var i=0; i<codeboxes.length; i++) {
		codeboxes[i].addEventListener('keyup', onCodeChange);
	}

	var toggleHeart = function() {
		var newXHR = new XMLHttpRequest();
		newXHR.open('GET', '/user/favourite/' + this.dataset.id);
		newXHR.send();
		this.classList.toggle('routelist__heart--selected');
		if (this.parentElement && this.parentElement.parentElement 
			&& this.parentElement.parentElement.classList 
			&& this.parentElement.parentElement.classList[0] 
			&& this.parentElement.parentElement.classList[0] =='routelist__item' ) {
			this.parentElement.parentElement.style.display = 'none';
		}
	};

	var hearts = document.querySelectorAll('.routelist--no-vue .routelist__heart, .hero__heart');
	for (var i=0; i<hearts.length; i++) {
		hearts[i].addEventListener('click', toggleHeart);
	}


	// Toplist filter listener
	window.addEventListener('DOMContentLoaded', function() {
		var filterForm = document.getElementById('toplist-filter');

		if (!filterForm) {
			return;
		}

		var submitFilters = function() {
			if (this.name === 'region') {
				var countyFilter = document.getElementById('select-municipality');
				if (countyFilter) {
					countyFilter.selectedIndex = 0;
				}
			}
			filterForm.submit();
		};

		var fields = document.querySelectorAll('#toplist-filter select, #toplist-filter input[type="radio"]');
		for (var i=0; i<fields.length; i++) {
			fields[i].addEventListener('change', submitFilters);
		}
	});

	var toplistSize = 10;

	var loadContent = function(url, element) {
		var newXHR = new XMLHttpRequest();
		var done = false;

		newXHR.onreadystatechange = function(event) {
			if (this.readyState == 4 && !done) {
				done = true;
				document.getElementById(element).innerHTML = this.responseText;
			}
		};

		newXHR.open('GET', url);
		newXHR.send();
	}


	window.nextPageToplist = function(route_id, offset) {
		offset += toplistSize;
		loadContent('/turar/toplist/' + route_id + '/' + offset, 'route-toplist');
		return false;
	};
	window.prevPageToplist = function(route_id, offset) {
		if (offset > 0) {
			offset -= toplistSize;
		}
		loadContent('/turar/toplist/' + route_id + '/' + offset, 'route-toplist');
		return false;
	};
	window.nextPageVisits = function(route_id, offset) {
		offset += toplistSize;
		loadContent('/turar/visits/' + route_id + '/' + offset, 'route-visits');
		return false;
	};
	window.prevPageVisits = function(route_id, offset) {
		if (offset > 0) {
			offset -= toplistSize;
		}
		loadContent('/turar/visits/' + route_id + '/' + offset, 'route-visits');
		return false;
	};	


})();

